import { TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { I18n } from 'utils/i18n';

const ControlLabel = forwardRef(
  ({ label = '', labelPrefix = '', name, control: Control = TextField, ...rest }, ref) => {
    return (
      <>
        <label htmlFor={name}>
          <Typography>{label || I18n.t(`${labelPrefix}.${name.split('.').pop()}`)}</Typography>
        </label>
        <Control id={name} name={name} ref={ref} {...rest} />
      </>
    );
  },
);
ControlLabel.propTypes = {
  label: PropTypes.string,
  labelPrefix: PropTypes.string,
  name: PropTypes.string.isRequired,
  control: PropTypes.func,
};

export default ControlLabel;
